<template>
  <div class="hw-box-gray">
    <button
      type="button"
      class="hw-button text officehome-menu-setting"
      @click="setBookmarkAddVisibleType(2)"
      v-if="bookmarkAddVisibleType === 1"
    >
      <font-awesome-icon :icon="['fas', 'plus']" />
      {{ $t('ADD_FAVORITE') }}
    </button>

    <div class="hw-modal-div-table" v-else>
      <div class="gt-d-table">
        <div class="gt-d-table-cell" style="width: 10%">{{ $t('NAME') }}</div>
        <div class="gt-d-table-cell">
          <input
            type="text"
            class="hw-input"
            v-model="bookmarkInfo.name"
            style="height:38px"
            maxlength="45"
            :placeholder="$t('PLEASE_ENTER_NAME_PLACEHOLDER')"
          />
        </div>
      </div>
      <div class="gt-d-table">
        <div class="gt-d-table-cell" style="width: 10%">URL</div>
        <div class="gt-d-table-cell">
          <input type="text" class="hw-input" v-model="bookmarkInfo.url" maxlength="500" style="height:38px" />
        </div>
      </div>
      <div class="gt-pt-20 gt-text-center" style="text-align:center">
        <button type="button" class="hw-button secondary" @click="cancel">
          {{ $t('CANCEL') }}
        </button>
        <button type="button" class="hw-button" v-show="bookmarkAddVisibleType === 2" @click="createBookmark">
          {{ $t('SAVE') }}
        </button>
        <button type="button" class="hw-button" v-show="bookmarkAddVisibleType === 3" @click="modifyBookmark">
          {{ $t('SAVE') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookmarkAdd',
  props: {
    bookmarkAddVisibleType: {
      type: Number,
      required: true,
    },
    modifyBookmarkInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      bookmarkInfo: {
        name: null,
        url: null,
        no: null,
      },
    };
  },
  watch: {
    modifyBookmarkInfo(modifyBookmarkInfo) {
      let urlPattern = /^(http|https):/;
      let url = modifyBookmarkInfo.bookmark.url;
      url = urlPattern.test(url) ? url : 'http://' + url;

      this.bookmarkInfo.name = modifyBookmarkInfo.bookmark.name;
      this.bookmarkInfo.url = url;
      this.bookmarkInfo.no = modifyBookmarkInfo.bookmark.no;
    },
    bookmarkAddVisibleType(type) {
      if (type === 3) {
        let urlPattern = /^(http|https):/;
        let url = this.modifyBookmarkInfo.bookmark.url;
        url = urlPattern.test(url) ? url : 'http://' + url;

        this.bookmarkInfo = {
          name: this.modifyBookmarkInfo.bookmark.name,
          url: url,
          no: this.modifyBookmarkInfo.no,
        };
      } else {
        this.bookmarkInfo = {
          name: null,
          url: null,
          no: null,
        };
      }
    },
  },
  methods: {
    cancel() {
      this.$emit('set-bookmark-add-visible-type', 1);
    },
    setBookmarkAddVisibleType(type) {
      this.$emit('set-bookmark-add-visible-type', type);
    },
    modifyBookmark() {
      if (!this.bookmarkInfo.name) {
        alert(this.$t('NAME_INPUT'));
        return false;
      }
      if (!this.bookmarkInfo.url) {
        alert(this.$t('URL_INPUT'));
        return false;
      }
      this.$emit('modify-bookmark', this.bookmarkInfo.no, this.bookmarkInfo.name, this.bookmarkInfo.url);
    },
    createBookmark() {
      if (!this.bookmarkInfo.name) {
        alert(this.$t('NAME_INPUT'));
        return false;
      }
      if (!this.bookmarkInfo.url) {
        alert(this.$t('URL_INPUT'));
        return false;
      }
      this.$emit('create-bookmark', this.bookmarkInfo.name, this.bookmarkInfo.url);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/base/variables';
.hw-button {
  display: inline-block;
  background-color: $primary-color;
  border: 1px solid $primary-color-hover;
  border-radius: 4px;
  color: #fff;
  padding: 5px 20px 6px;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  transition-duration: 0.1s;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;

  //hover
  &:hover,
  &:focus {
    color: #fff;
    background: darken($primary-color-hover, 10%);
    border-color: darken($primary-color-hover, 10%);
    outline: none;
  }

  //disabled
  &[disabled],
  &:disabled {
    cursor: default;
    opacity: 0.5;
    &:hover {
      background: $primary-color;
      border-color: $primary-color-hover;
    }
  }

  &.secondary {
    background-color: $secondary-color;
    border-color: $secondary-color-hover;
    color: #333;
    &:hover,
    &:focus {
      background-color: $secondary-color-hover;
      border-color: $secondary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $secondary-color;
        border-color: $secondary-color-hover;
      }
    }
  }

  &.info {
    background-color: $info-color;
    border-color: $info-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $info-color-hover;
      border-color: $info-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $info-color;
        border-color: $info-color-hover;
      }
    }
  }

  &.warning {
    background-color: $warning-color;
    border-color: $warning-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $warning-color-hover;
      border-color: $warning-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $warning-color;
        border-color: $warning-color-hover;
      }
    }
  }

  &.danger {
    background-color: $danger-color;
    border-color: $danger-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $danger-color-hover;
      border-color: $danger-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $danger-color;
        border-color: $danger-color-hover;
      }
    }
  }

  &.text {
    color: $primary-color;
    padding: 0 10px;
    background: transparent;
    border-color: transparent;
    //hover
    &:hover,
    &:focus {
      color: $primary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        color: $primary-color;
        background: transparent;
        border-color: transparent;
        opacity: 0.5;
      }
    }
  }

  &.outline-blue {
    background-color: #fff;
    border: 1px solid #c8c8c8;
    color: #2c86dc;
    &:hover {
      border-color: #2c86dc;
    }
  }

  &.outline-gray {
    background: #f1f1f1;
    border: 1px solid #c8c8c8;
    color: #444;
    &:hover {
      border-color: #8c8c8c;
    }
  }

  &.outline-gray2 {
    background: #fff;
    border: 1px solid #d6d6d6;
    color: #333;
    padding-left: 12px;
    padding-right: 12px;
    > i {
      color: #909090;
      float: right;
      margin-top: 4px;
      margin-left: 10px;
    }
    &:hover {
      background: #f6f6f6;
    }
    &:focus {
      > i {
        color: #575757;
      }
    }
    &[disabled],
    &:disabled {
      border-color: #f2f2f2;
      background: #ffffff;
      &,
      > i {
        color: #d0d0d0;
      }
    }
  }

  &.rounded {
    border-radius: 4px;
  }

  //이웃하는 버튼 간격
  & + .hw-button {
    margin-left: 14px;
  }
}
.hw-box-gray {
  padding: 20px;
  width: 100%;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  > * {
    max-width: 100%; // ie bug fix
  }
  .gt-d-table + .gt-d-table {
    margin-top: 12px;
  }
  .gt-d-table-cell {
    vertical-align: middle;
    &:first-child {
      width: 20%;
      line-height: 34px;
    }
  }
  .hw-modal-div-table {
    .hw-input {
      display: inline-block;
      width: 100%;
      min-height: 34px;
      font-size: 14px;
      padding: 0 10px;
      border: 1px solid #d6d6d6;
      transition-duration: 0.2s;
      box-sizing: border-box;
      &:hover {
        border-color: #c0c4cc;
      }
      &:focus {
        border-color: $primary-color;
        outline: none;
      }
      &::placeholder {
        color: #acacac;
      }
      &[disabled] {
        background: #f8f8f8;
        border-color: #d6d6d6;
        user-select: none;
      }
      &.sm {
        height: 30px;
        min-height: 30px;
      }
      &.lg {
        height: 40px;
      }
    }
  }
}
</style>
